
document.addEventListener('DOMContentLoaded', () => {
    console.log("DOM content loaded");
  
    setTimeout(() => {
      console.log("Timeout executed");
  
      const bindRemoveButtonEvents = () => {
     
        const removeButtons = document.querySelectorAll('.offer-remove');
        console.log("Remove buttons found:", removeButtons.length);
        
        // Check if we found any buttons before trying to loop
        if (removeButtons.length === 0) {
          console.log("No remove buttons found on page");
          return;
        }
        
        removeButtons.forEach(button => {
          if (!button.dataset.bound) {
            button.dataset.bound = "true"; // Prevent rebinding 
            button.addEventListener('click', (event) => {
              event.preventDefault();
              console.log("Remove button clicked");
              removeOfferItems();
            });
            console.log("Event listener attached to remove button");
          }
        });
      };
  
      const removeOfferItems = async () => {
        try {
          console.log("Removing offer items...");
          const cartResponse = await fetch('/cart.js');
          if (!cartResponse.ok) throw new Error('Failed to fetch cart data');
  
          const cart = await cartResponse.json();
          console.log("Cart data:", cart);
          
          // Use optional chaining and ensure properties exists
          const offerItems = cart.items.filter(item => 
            item.properties && item.properties['Offer'] !== undefined
          );
          
          console.log("Offer items found:", offerItems.length);
  
          if (offerItems.length === 0) {
            console.log("No offer items found in cart");
            return;
          }
  
          const updates = {};
          offerItems.forEach(item => {
            console.log("Setting item to remove:", item.key);
            updates[item.key] = 0;
          });
  
          console.log("Sending updates to cart:", updates);
          const updateResponse = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ updates }),
          });
  
          if (!updateResponse.ok) {
            const errorText = await updateResponse.text();
            console.error("Cart update failed with response:", errorText);
            
            // Try alternative format as fallback
            console.log("Trying alternative update format...");
            const items = offerItems.map(item => ({
              id: item.key,
              quantity: 0
            }));
            
            const alternativeResponse = await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({ items }),
            });
            
            if (!alternativeResponse.ok) {
              throw new Error('All cart update attempts failed');
            }
            
            const result = await alternativeResponse.json();
            console.log('Cart updated successfully with alternative format:', result);
            // window.location.reload();

        
                var rsetelement = document.querySelector('.quick_cart_loader');
                rsetelement.setAttribute('hidden');
            const response = await fetch('/?sections=mini_cart');
                            const sectionData = await response.json();
                          
                            const drawerId = '#t4s-mini_cart';
                            const drawerEl = document.querySelector(drawerId);
                          
                            if (drawerEl && sectionData['mini_cart']) {
                              drawerEl.innerHTML = sectionData['mini_cart'];
                            }
            return;
          }
  
          const result = await updateResponse.json();
          console.log('Cart updated successfully:', result);
        //   window.location.reload();
        const response = await fetch('/?sections=mini_cart');
                            const sectionData = await response.json();
                          
                            const drawerId = '#t4s-mini_cart';
                            const drawerEl = document.querySelector(drawerId);
                          
                            if (drawerEl && sectionData['mini_cart']) {
                              drawerEl.innerHTML = sectionData['mini_cart'];
                            }
        } catch (error) {
          console.error('Error updating cart:', error);
        }
      };
      const updateCartBubble = async () => {
        try {
          // Get the latest cart data
          const cartResponse = await fetch('/cart.js');
          if (!cartResponse.ok) throw new Error('Failed to fetch cart data');
          
          const cart = await cartResponse.json();
          console.log('Updating cart bubble with count:', cart.item_count);
          
          // Update the count element
          const countElements = document.querySelectorAll('[data-cart-count]');
          countElements.forEach(element => {
            element.textContent = cart.item_count;
            
            // Make count visible if there are items, hide if zero
            if (cart.item_count > 0) {
              element.classList.remove('t4s-op-0');
            } else {
              element.classList.add('t4s-op-0');
            }
          });
          
          // Also update the mini cart drawer if it exists
          const drawerResponse = await fetch('/?sections=mini_cart');
          const sectionData = await drawerResponse.json();
          
          const drawerId = '#t4s-mini_cart';
          const drawerEl = document.querySelector(drawerId);
          
          if (drawerEl && sectionData['mini_cart']) {
            drawerEl.innerHTML = sectionData['mini_cart'];
          }
          
          console.log('Cart bubble updated successfully');
        } catch (error) {
          console.error('Error updating cart bubble:', error);
        }
      };
      
// Function to handle incrementing offer quantities
const incrementOfferItems = async () => {
    try {
      console.log("Incrementing offer items...");
      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) throw new Error('Failed to fetch cart data');
  
      const cart = await cartResponse.json();
      // Use proper filtering with null check
      const offerItems = cart.items.filter(item => 
        item.properties && item.properties['Offer'] !== undefined
      );
  
      console.log("Offer items for increment:", offerItems.length);
      if (offerItems.length === 0) {
        console.log('No offer items found in cart');
        return;
      }
  
      const updates = {};
      offerItems.forEach(item => {
        updates[item.key] = item.quantity + 1;
      });
  
      console.log('Updating quantities for offer items:', updates);
  
      const updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ updates }),
      });
  
      if (!updateResponse.ok) {
        const errorText = await updateResponse.text();
        console.error("Cart update failed with response:", errorText);
        throw new Error('Cart update failed: ' + errorText);
      }
  
      const result = await updateResponse.json();
      console.log('Cart updated:', result);
      
      // Generate discount after updating cart quantity
      await generateDiscount(result.items);
      await updateCartBubble();
      var rsetelement = document.querySelector('.quick_cart_loader');
      rsetelement.setAttribute('hidden');
      // Update cart drawer instead of page reload
      const response = await fetch('/?sections=mini_cart');
      const sectionData = await response.json();
      
      const drawerId = '#t4s-mini_cart';
      const drawerEl = document.querySelector(drawerId);
      
      if (drawerEl && sectionData['mini_cart']) {
        drawerEl.innerHTML = sectionData['mini_cart'];
      }
      
    } catch (error) {
      console.error('Error incrementing offer items:', error);
    }
  };
  
  // Function to generate discount based on cart items
  const generateDiscount = async (cartItems) => {
    try {
        console.log("cartItems",cartItems)
      // Filter offer items
      const offerItems = cartItems.filter(item => 
        item.properties && item.properties['Offer'] !== undefined
      );
      
      if (offerItems.length === 0) {
        console.log('No offer items found to generate discount');
        return;
      }
      
      // Extract variant IDs
      const productIds = offerItems.map(item => item.variant_id.toString());
      
      // Calculate total price
      let totalPrice = 0;
      let offerPrice = parseFloat(document.querySelector('.psptem')?.textContent.replace(/[^0-9.-]+/g, "") || "0");
      offerPrice = offerPrice * cartItems[0].quantity 
      offerItems.forEach(item => {
        
        totalPrice += (item.price * item.quantity) / 100; // Convert cents to dollars
      });
      
      // Get offer price from the page
      
      // Generate hash
      const currentDate = new Date();
      const formattedDate = currentDate.getFullYear().toString() +
                      (currentDate.getMonth() + 1).toString().padStart(2, '0') +
                      currentDate.getDate().toString().padStart(2, '0');
      
      const hashFormate = String(offerPrice.toString() + formattedDate);
      var hashResult = CryptoJS.MD5(hashFormate).toString(CryptoJS.enc.Hex);
      
      console.log('Generating discount for items:', productIds);
      console.log('Total price:', totalPrice, 'Offer price:', offerPrice);
      // Make API request to generate discount
      let response = await fetch('https://cpanel.mensabrands.com/BYOB_latest/public/discountGenerate', {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-type": "application/json",
          "Authorization": `Bearer ${window.sessionToken}`
        },
        body: JSON.stringify({
          variant_IDs: productIds,
          total_price: totalPrice,
          offer_price: offerPrice,
          htop: hashResult,
          store_name: "BotanicHearthUSA",
        })
      });
      
      let res = await response.json();
      let discount_code = res['Discount code'];
      console.log('New discount code generated:', discount_code);

      const manualCoupon = sessionStorage.getItem('botanic_applied_coupon') || localStorage.getItem('applied_coupon_code');
      if (manualCoupon) {
        console.log('Skipping auto discount because a coupon is already applied:', manualCoupon);
        return;
      }
      
      // Apply discount
      await jQuery.ajax({
        url: `/discount/${discount_code}`,
        method: 'GET',
        success: function () {
          console.log('New discount applied successfully');
        },
        error: function (err) {
          console.error('Discount apply error:', err);
        }
      });
      
    } catch (error) {
      console.error('Error generating discount:', error);
    }
  };
  
      // Function to handle decrementing offer quantities
      const decrementOfferItems = async () => {
        try {
            console.log("Incrementing offer items...");
            const cartResponse = await fetch('/cart.js');
            if (!cartResponse.ok) throw new Error('Failed to fetch cart data');
        
            const cart = await cartResponse.json();
            // Use proper filtering with null check
            const offerItems = cart.items.filter(item => 
              item.properties && item.properties['Offer'] !== undefined
            );
        
            console.log("Offer items for increment:", offerItems.length);
            if (offerItems.length === 0) {
              console.log('No offer items found in cart');
              return;
            }
        
            const updates = {};
            offerItems.forEach(item => {
              updates[item.key] = item.quantity - 1; 
            });
        
            console.log('Updating quantities for offer items:', updates);
        
            const updateResponse = await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({ updates }),
            });
        
            if (!updateResponse.ok) {
              const errorText = await updateResponse.text();
              console.error("Cart update failed with response:", errorText);
              throw new Error('Cart update failed: ' + errorText);
            }
        
            const result = await updateResponse.json();
            console.log('Cart updated:', result);
            
            // Generate discount after updating cart quantity
            await generateDiscount(result.items);
            
            // Update cart drawer instead of page reload
            const response = await fetch('/?sections=mini_cart');
            const sectionData = await response.json();
            
            const drawerId = '#t4s-mini_cart';
            const drawerEl = document.querySelector(drawerId);
            
            if (drawerEl && sectionData['mini_cart']) {
              drawerEl.innerHTML = sectionData['mini_cart'];
            }
            
          } catch (error) {
            console.error('Error incrementing offer items:', error);
          }
      };
  
      // Function to bind all event handlers
      const bindAllCartEvents = () => {
        // Bind remove buttons
        bindRemoveButtonEvents();
        
        // Bind plus button - use querySelectorAll and check length
        const plusButtons = document.querySelectorAll('.offer-plus');
        console.log("Plus buttons found:", plusButtons.length);
        
        if (plusButtons.length > 0) {
          plusButtons.forEach(button => {
            if (!button.dataset.bound) {
              button.dataset.bound = "true";
              button.addEventListener('click', (event) => {
                event.preventDefault();
                console.log("Plus button clicked");
                var cartItem = button.closest('.quick-cart__item.offer-product');
                if (cartItem) {
                    var element = cartItem.querySelector('.quick_cart_loader');
                    if (element && element.hasAttribute('hidden')) {
                        element.removeAttribute('hidden');
                        console.log("loader");
                    }
                }
                incrementOfferItems();
              });
              console.log("Event listener attached to plus button");
            }
          });
        }
        
        // Bind minus button
        const minusButtons = document.querySelectorAll('.offer-minus');
        console.log("Minus buttons found:", minusButtons.length);
        
        if (minusButtons.length > 0) {
          minusButtons.forEach(button => {
            if (!button.dataset.bound) {
              button.dataset.bound = "true";
              button.addEventListener('click', (event) => {
                event.preventDefault();
                console.log("Minus button clicked");
                var cartItem = button.closest('.quick-cart__item.offer-product');
                if (cartItem) {
                    var element = cartItem.querySelector('.quick_cart_loader');
                    if (element && element.hasAttribute('hidden')) {
                        element.removeAttribute('hidden');
                        console.log("loader");
                    }
                }
                decrementOfferItems();
              });
              console.log("Event listener attached to minus button");
            }
          });
        }
        
        // Bind quantity input change events
        const quantityInputs = document.querySelectorAll('.offer-input');
        console.log("Quantity inputs found:", quantityInputs.length);
        
        if (quantityInputs.length > 0) {
          quantityInputs.forEach(input => {
            if (!input.dataset.bound) {
              input.dataset.bound = "true";
              input.addEventListener('change', (event) => {
                handleQuantityChange(event);
              });
              console.log("Event listener attached to quantity input");
            }
          });
        }
      };
      
      // Handle quantity input change
      const handleQuantityChange = async (event) => {
        const newQty = parseInt(event.target.value, 10);
        const lineItemKey = event.target.getAttribute('data-id');
        
        if (!lineItemKey) {
          console.error("No line item key found on input element");
          return;
        }
        
        if (isNaN(newQty) || newQty < 0) {
          console.warn('Invalid quantity entered');
          return;
        }
        
        try {
          const updates = {};
          updates[lineItemKey] = newQty;
          
          console.log('Updating cart with new quantity:', updates);
          
          const updateResponse = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ updates }),
          });
          
          if (!updateResponse.ok) {
            const errorText = await updateResponse.text();
            throw new Error('Cart update failed: ' + errorText);
          }
          
          const result = await updateResponse.json();
          console.log('Cart updated after manual input:', result);
        //   window.location.reload();
        const response = await fetch('/?sections=mini_cart');
                            const sectionData = await response.json();
                          
                            const drawerId = '#t4s-mini_cart';
                            const drawerEl = document.querySelector(drawerId);
                          
                            if (drawerEl && sectionData['mini_cart']) {
                              drawerEl.innerHTML = sectionData['mini_cart'];
                            }
        } catch (error) {
          console.error('Error updating cart from input field:', error);
        }
      };
  
      // Initial bind (for elements already on the page)
      bindAllCartEvents();
  
      // MutationObserver for dynamically added elements
      const observer = new MutationObserver((mutations) => {
        let shouldBind = false;
        
        // Check if any relevant elements were added
        mutations.forEach(mutation => {
          if (mutation.addedNodes.length) {
            mutation.addedNodes.forEach(node => {
              if (node.nodeType === 1) { // Element node
                if (
                  node.classList?.contains('offer-remove') || 
                  node.classList?.contains('offer-plus') ||
                  node.classList?.contains('offer-minus') ||
                  node.classList?.contains('offer-input') ||
                  node.querySelector?.('.offer-remove') ||
                  node.querySelector?.('.offer-plus') ||
                  node.querySelector?.('.offer-minus') ||
                  node.querySelector?.('.offer-input')
                ) {
                  shouldBind = true;
                }
              }
            });
          }
        });
        
        // Only rebind if relevant elements were added
        if (shouldBind) {
          console.log("DOM mutations detected - rebinding cart events");
          bindAllCartEvents();
        }
      });
  
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
  
    }, 2000); // Wait for Shopify to fully render elements
  }); 

window.addEventListener('DOMContentLoaded', () => {
    this.scrollSection();
    this.imageAnimation();
    this.handleScroll();
    // Add scroll event listener to the window

    const radioButtons = document.querySelectorAll('.collection-item input[type="radio"]');
    let selectedRadioArray = [];

    radioButtons.forEach((radioButton)=> {
        radioButton.addEventListener("change", (event) => {
            let currentTarget = event.currentTarget;
            let addtobox = currentTarget.closest('.collection-item').querySelector('.product-selectVarient');
            selectedRadioArray = Array.from(currentTarget.closest('.collection-item').querySelectorAll('input[type="radio"]:checked')).map(radio => radio.value);
            console.log(currentTarget.value);
            const variantPicker = currentTarget.closest('.collection-item').querySelector('#product_variant');
            const variantLabel = currentTarget.closest('.variant-radio-wrapper').previousElementSibling;
            variantLabel.querySelector('span.vat-set-vl').innerText = '- '+ currentTarget.value;
            const jsonString = variantPicker.textContent.trim();
            const variantsInfo = JSON.parse(jsonString);
            console.log('jsonDataString',variantsInfo);
            const selectedVariant = variantsInfo.find((variant) => {
                return variant.options.every((option, index) => {
                    return option === selectedRadioArray[index];
                });
            });
            if (selectedVariant != undefined) {
                const selectedVariantId = selectedVariant.id;
                addtobox.dataset.idVariant=selectedVariantId;
            }
        });
    });
    
    window.addEventListener('scroll', scrollSection);

  
    var addToCartButton = document.querySelector('.offer-add-to-cart .product-form__cart-submit');
    var addToCartButtonText = document.querySelector('.offer-add-to-cart .product-form__cart-submit span');
    var bkupradioButtons = document.querySelectorAll('.button.select-btn');
  
    var openCart = document.querySelector('.open-cart');
    var closePopup = document.querySelector('.close-popup');
    var popupWrn;


    if (addToCartButton) {
        addToCartButton.addEventListener('click', async function(event) {
            // debugger;
            event.preventDefault();
            addToCartButtonText.innerHTML = "Creating";
            addToCartButton.disabled = true;
            addToCartButton.classList.add('spinning');
            let response = await fetch('/cart.js');
            let cart = await response.json();
            for (let item of cart.items) {
                if (item.properties && item.properties.Offer) {
                    const popupWrn = document.querySelector('.popup-container.popup-style-2');
                    if (popupWrn) {
                        popupWrn.classList.add('active');
                    }
                    return;
                }
            }

            const radioButtons = document.querySelectorAll('.button.select-btn');
            const selectedRadioData = [];
            radioButtons.forEach(function(radioButton) {
                if (radioButton.checked) {
                    const radioData = radioButton.getAttribute('data-id-variant');
                    selectedRadioData.push(radioData);
                }
            });

            if (selectedRadioData.length === 0) {
                console.warn('No product selected.');
                return;
            }

            let selectedRadioDatas = [];
            let total = 0;

            radioButtons.forEach(function(radioButton) {
                if (radioButton.checked) {
                    let radioData = radioButton.getAttribute('data-id-variant');
                    let priceCurrent = radioButton.getAttribute('data-price-variant');
                    let priceNumeric = parseFloat(priceCurrent);
                    total += priceNumeric;
                    selectedRadioDatas.push(radioData);
                }
            });

            let productIds = selectedRadioDatas;
            let mainOfferPrices = parseFloat(document.querySelector('.psptem').textContent.replace(/[^0-9.-]+/g, ""));
            let totalPrice = total;
            let offerPrice = mainOfferPrices;
            const currentDate = new Date();
            const formattedDate = currentDate.getFullYear().toString() +
                            (currentDate.getMonth() + 1).toString().padStart(2, '0') +
                            currentDate.getDate().toString().padStart(2, '0');
      
            const hashFormate = String(offerPrice.toString() + formattedDate);
            var hashResult =  CryptoJS.MD5(hashFormate).toString(CryptoJS.enc.Hex);
    
            const mainOfferTitle = document.querySelector('.prd-image-title h3').textContent;
            const mainOfferImage = document.querySelector('.prd-image-title img');
            const mainSrc = mainOfferImage ? mainOfferImage.getAttribute('src') : null;
            const mainOfferPrice = document.querySelector('.psptem').textContent;
            const currentUrl = window.location.href;

            for (let index = 0; index < selectedRadioData.length; index++) {
                await addProductWithRetry(selectedRadioData[index], {
                    'Offer': mainOfferTitle,
                    'Price': mainOfferPrice,
                    'Image': mainSrc,
                    'PageUrl': currentUrl
                }, 3);
            }
            // debugger;
            try {
                let response = await fetch('https://cpanel.mensabrands.com/BYOB_latest/public/discountGenerate', {
                    method: "POST",
                    headers: {
                        "Accept": "application/json",
                        "Content-type": "application/json",
                        "Authorization": `Bearer ${window.sessionToken}`
                    },
                    body: JSON.stringify({
                        variant_IDs: productIds,
                        total_price: totalPrice,
                        offer_price: offerPrice,
                        htop: hashResult,
                    store_name: "BotanicHearthUSA",
                    })
                });
                let res = await response.json();
                let discount_code = res['Discount code'];
                console.log('discount_code');
                console.log(discount_code);
                await jQuery.ajax({
                    url: `/discount/${discount_code}`,
                    method: 'GET',
                    success: async function () {
                        console.log('Discount applied');
                // debugger; 
                        // Update button UI
                        addToCartButtonText.innerHTML = "Created";
                        addToCartButton.classList.remove('spinning');
                        addToCartButton.disabled = false;
                
                        try {
                            // Fetch updated drawer content
                            const response = await fetch('/?sections=mini_cart');
                            const sectionData = await response.json();
                          
                            const drawerId = '#t4s-mini_cart';
                            const drawerEl = document.querySelector(drawerId);
                          
                            if (drawerEl && sectionData['mini_cart']) {
                              drawerEl.innerHTML = sectionData['mini_cart'];
                            }
                            try {
                                // Get the latest cart data
                                const cartResponse = await fetch('/cart.js');
                                if (!cartResponse.ok) throw new Error('Failed to fetch cart data');
                                
                                const cart = await cartResponse.json();
                                console.log('Updating cart bubble with count:', cart.item_count);
                                
                                // Update the count element
                                const countElements = document.querySelectorAll('[data-cart-count]');
                                const htmlEl = document.querySelector('html');
                                const prefix = 't4s-cart-count-';
                                // Replace this with the actual dynamic value if used in JS

                                // Remove existing class with the prefix
                                htmlEl.classList.forEach(cls => {
                                    console.log("clssss",cls)
                                if (cls.startsWith(prefix)) {
                                    htmlEl.classList.remove(cls);
                                }
                                });

                                htmlEl.classList.add(`${prefix}${cart.item_count}`); 

                                countElements.forEach(element => {
                                   console.log("element",element)
                                  element.textContent = cart.item_count;
                                  
                                  // Make count visible if there are items, hide if zero
                                  if (cart.item_count > 0) {
                                    element.classList.remove('t4s-op-0');
                                  } else {
                                    element.classList.add('t4s-op-0');
                                  }
                                });
                                
                                
                                // Also update the mini cart drawer if it exists
                                const drawerResponse = await fetch('/?sections=mini_cart');
                                const sectionData = await drawerResponse.json();
                                
                                const drawerId = '#t4s-mini_cart';
                                const drawerEl = document.querySelector(drawerId);
                                
                                if (drawerEl && sectionData['mini_cart']) {
                                  drawerEl.innerHTML = sectionData['mini_cart'];
                                }
                                
                                console.log('Cart bubble updated successfully');
                              } catch (error) {
                                console.error('Error updating cart bubble:', error);
                              }
                            // Open the drawer
                            const cartIcon = document.querySelector('[data-drawer-options*="#t4s-mini_cart"]');
                            if (cartIcon) {
                                cartIcon.click();
                            } else {
                                const event = new CustomEvent('drawer:open', {
                                    detail: { id: drawerId }
                                });
                                document.dispatchEvent(event);
                            }
                
                        } catch (error) {
                            console.error('Error updating cart drawer:', error);
                        }
                    },
                    error: function (err) {
                        console.error('Discount apply error:', err);
                    }
                });
              
            } catch (error) {
                console.error('Error:', error);
            }
        });
        }
  
    if (closePopup) {
        closePopup.addEventListener('click', function(event) {
            event.preventDefault();
            popupWrn = document.querySelector('.popup-container.popup-style-2');
            popupWrn.classList.remove('active');
        });
    }
  
    if (openCart) {
        openCart.addEventListener('click', function(event) {
            event.preventDefault();
           const cartIcon = document.querySelector('[data-drawer-options*="#t4s-mini_cart"]');
            if (cartIcon) {
                cartIcon.click();
                document.dispatchEvent(event);
              
            } else {
                const event = new CustomEvent('drawer:open', {
                    detail: { id: '#t4s-mini_cart' }
                });
                document.dispatchEvent(event);
            }
           popupWrn = document.querySelector('.popup-container.popup-style-2');
            popupWrn.classList.remove('active');
        });
    }
   

    if (replaceButton) {
        replaceButton.addEventListener('click', async function (event) {
            event.preventDefault();
    
            try {
                replaceButton.disabled = true;
                replaceButton.classList.add('spinning');
    
                // Fetch current cart HTML
                const cartResponse = await fetch('/cart');
                const cartHtmlText = await cartResponse.text();
                const cartHtml = new DOMParser().parseFromString(cartHtmlText, "text/html");
                const hiddenZone = cartHtml.querySelector('.hidden-zone');
    
                if (!hiddenZone) throw new Error('Missing .hidden-zone in cart');
    // debugger;
                // Find all items to remove
                const inputFields = hiddenZone.querySelectorAll('.js-qty__num');
                if (!inputFields.length) throw new Error('No quantity inputs found');
    
                const formData = new FormData();
                inputFields.forEach(input => {
                    const id = input.getAttribute('data-product-id');
                    formData.append(`updates[${id}]`, 0); // Set quantity to 0 (remove)
                });
    
                // Update cart: remove current items
                await fetch('/cart/update.js', {
                    method: 'POST',
                    body: formData
                });
    
                // Collect selected new product variants
                const selectedVariants = [];
                let total = 0;
                document.querySelectorAll('.button.select-btn:checked').forEach(btn => {
                    const id = btn.getAttribute('data-id-variant');
                    const price = parseFloat(btn.getAttribute('data-price-variant')) || 0;
                    total += price;
                    selectedVariants.push(id);
                });
    
                if (!selectedVariants.length) throw new Error('No products selected');
    
                const offerTitle = document.querySelector('.prd-image-title h3')?.textContent || '';
                const offerImage = document.querySelector('.prd-image-title img')?.getAttribute('src') || '';
                const offerPriceText = document.querySelector('.psptem')?.textContent || '';
                const offerPrice = parseFloat(offerPriceText.replace(/[^0-9.-]+/g, '')) || total;
                const currentUrl = window.location.href;
    
                const today = new Date();
                const hashInput = `${offerPrice}${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
                const hashResult = CryptoJS.MD5(hashInput).toString(CryptoJS.enc.Hex);
    // debugger;
                // Generate discount code
                const discountRes = await fetch('https://cpanel.mensabrands.com/BYOB_latest/public/discountGenerate', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${window.sessionToken}`
                    },
                    body: JSON.stringify({
                        variant_IDs: selectedVariants,
                        total_price: total,
                        offer_price: offerPrice,
                        htop: hashResult,
                        store_name: "BotanicHearthUSA"
                    })
                });
    
                const discountData = await discountRes.json();
                const discountCode = discountData['Discount code'];
    
                // Apply discount
                await fetch(`/discount/${discountCode}`, { method: 'GET' });
    
                // Add new products to cart with properties
                for (let id of selectedVariants) {
                    await addProductWithRetry(id, {
                        'Offer': offerTitle,
                        'Price': offerPriceText,
                        'Image': offerImage,
                        'PageUrl': currentUrl
                    }, 3);
                }
                // debugger;
    
                // Fetch and update mini cart drawer
                const drawerRes = await fetch('/?sections=mini_cart');
                const drawerData = await drawerRes.json();
                const drawerEl = document.querySelector('#t4s-mini_cart');
                if (drawerEl && drawerData['mini_cart']) {
                    drawerEl.innerHTML = drawerData['mini_cart'];
                }
    
                // Open the drawer
                const cartIcon = document.querySelector('[data-drawer-options*="#t4s-mini_cart"]');
                if (cartIcon) {
                    cartIcon.click();
                } else {
                    const event = new CustomEvent('drawer:open', {
                        detail: { id: '#t4s-mini_cart' }
                    });
                    document.dispatchEvent(event);
                }
    
                // UI cleanup
                addToCartButtonText.innerHTML = "Created";
                addToCartButton.classList.remove('spinning');
                addToCartButton.disabled = false;
    
            } catch (error) {
                console.error('Replace bundle error:', error);
                addToCartButtonText.innerHTML = "Error";
                addToCartButton.classList.remove('spinning');
                addToCartButton.disabled = false;
            }
        });
    }
    



});

    document.getElementById("searchInput").addEventListener("keydown", function(event) {
        if (event.key === "Enter") {
            event.preventDefault();
        }
    });

    var checkboxes = document.querySelectorAll('#checkboxes');
    var addToCartBtn = document.querySelector(".product-form__cart-submit");
        addToCartBtn.setAttribute("disabled", "disabled");
    // Attach click event listener to each div element
    checkboxes.forEach(function(checkbox) {
        checkbox.addEventListener('click', function() {
            // Get the value of the data-button-id attribute
            var buttonId = this.getAttribute('data-button-id');
            var limitId = this.getAttribute('data-product-limit');
            var sectionId = this.getAttribute('data-sec-id');
            var productName = this.getAttribute('data-product-name');
            
            // For hide and show add to cart button
            var addedToCartElements = document.querySelectorAll(".added_to_cart");
            
            var anyNotDisplayedBlock = false;

            // Iterate over each element
            addedToCartElements.forEach(function(element) {
                if (getComputedStyle(element).display !== 'block') {
                    anyNotDisplayedBlock = true;
                }
            });
            
            if (!anyNotDisplayedBlock) {
                addToCartBtn.removeAttribute("disabled"); 
                addToCartBtn.classList.remove("btn--secondary"); 
                addToCartBtn.classList.add("btn--primary"); 
            } else {
                addToCartBtn.setAttribute("disabled", "disabled"); 
                addToCartBtn.classList.add("btn--secondary"); 
                addToCartBtn.classList.remove("btn--primary"); 
            }
            
        

            var checkboxMain = document.getElementById(buttonId);

            // Attach click event listener
            checkboxMain.addEventListener('click', function(event) {

                    // Function to close the popup
    function closePopup(event) {
        // Get the data-popup attribute value from the clicked close button
        const popupId = event.currentTarget.getAttribute('data-popup');
        var checkboxMainPopup = document.getElementById(popupId);
        // Find the popup with the matching data-popup attribute
        const popup = document.querySelector(`.varient-popup[data-popup="${popupId}"]`);

        // Hide the popup
        if (popup) {
        popup.classList.remove('active');
        checkboxMainPopup.classList.add('product-varientbutton');
        }
    }

    function closePopupRepalce(event) {
    
        // Check if the clicked element is a close button
        if (event.target.closest('.close-popup')) {
        event.preventDefault(); // Prevent the default action of the anchor tag
        
        // Find the closest popup container
        const popupContainer = event.target.closest('.popup-container');
        
        // Remove the 'active' class from the popup container
        if (popupContainer) {
            popupContainer.classList.remove('active');
        }
        }
    }

            // Add event listener to all close buttons
            document.querySelectorAll('.varient-popup .close-popup').forEach(button => {
                button.addEventListener('click', closePopup);
            });
            document.querySelectorAll('.popup-content .close-popup').forEach(button => {
                button.addEventListener('click', closePopupRepalce);
            });
                // Check if the checkbox is checked
                if (event.target.classList.contains('product-varientbutton')) {
                    console.log('Popup toggled');
                    var checkboxMainPopups = document.getElementById(buttonId);
                    var variantPopup = document.querySelector(`.varient-popup[data-popup="${buttonId}"]`);
                    variantPopup.classList.add('active');
                    checkboxMainPopups.classList.add('button');
                    checkboxMainPopups.classList.remove('product-varientbutton');
                    checkboxMainPopups.checked= false;
                    return;
                }
                // Rest of the code for handling checkboxes
                var label = event.target.nextElementSibling;
                label.textContent = "";
                if (event.target.checked) {
                    createHiddenInput(productName);
                    label.textContent = "Remove from Box";
                } else {
                    removeHiddenInput(productName);
                    label.textContent = "Add to Box";
                }
            
                const checkboxesCount = document.querySelectorAll('#checkboxes input[data-id-products="'+ sectionId +'"]');
                const checkboxes = document.querySelectorAll('#checkboxes input[data-id-products="'+ sectionId +'"]');
                const showCount = document.querySelector('#checkbox_count_'+ sectionId +'_product');
                const addedSec = document.querySelector('#cart_'+ sectionId +'_added');
                const tabComplete = document.querySelector('.parent_'+ sectionId);
                const allCheckboxes = document.querySelectorAll('.select-btn');
            
                let checkedCount = 0;
                let totalPrice = 0;
                let selectedCount = 0;
                checkboxesCount.forEach(function(checkbox) {
                    if (checkbox.checked) {
                        checkedCount++;
                    }
                });
            
                allCheckboxes.forEach(checkbox => {
                    if (checkbox.checked) {
                        const price = parseFloat(checkbox.getAttribute('data-price-variant'));
                        totalPrice += price;
                        selectedCount++;
                    }
                });
            
                if (totalPrice) {
                    document.getElementById('total-price').style.display = "block";
                    document.getElementById('total-price').textContent = "₹ " + totalPrice.toFixed(2).replace(/\.00$/, '');
                    document.getElementById('total-products').textContent = "(" + selectedCount + ")";
                    document.querySelector('.products-count').style.display = 'block';
                } else {
                    document.querySelector('.products-count').style.display = 'none';
                    document.getElementById('total-price').style.display = "none";
                }
            
                if (limitId == checkedCount) {
                    checkboxes.forEach(function(checkbox) {
                        showCount.style.display = "none";
                        addedSec.style.display = "block";
                        tabComplete.classList.add('complete');
                        showCount.textContent = checkedCount;
                        data = checkbox.getAttribute('data-step');
                        var activeTab = document.querySelector('.tab-content[data-id="tab' + data + '"]');
                        activeTab.style.marginTop = '3%';
                        console.log('dsfsdfsd');
                        var nextTab = activeTab.nextElementSibling;
                        if (nextTab) {
                            activeTab.classList.remove('active-tab-content');
                            nextTab.classList.add('active-tab-content');
                            nextTab.scrollIntoView({ behavior: 'smooth' });
                            var scrollPosition = nextTab.getBoundingClientRect().top - (window.innerHeight * 0.2);
                            window.scrollBy({ top: scrollPosition, behavior: 'smooth' });
                        }
                        if (!checkbox.checked) {
                            checkbox.disabled = true;
                            checkbox.classList.add("disabled");
                        }
                    });
                } else {
                    if (checkedCount != 0) {
                        addedSec.style.display = "none";
                        showCount.style.display = "block";
                        showCount.textContent = checkedCount;
                    } else {
                        showCount.style.display = "none";
                        addedSec.style.display = "none";
                        showCount.textContent = checkedCount;
                    }
                    checkboxes.forEach(function(checkbox) {
                        if (!checkbox.checked) {
                            checkbox.disabled = false;
                            checkbox.classList.remove("disabled");
                        }
                    });
                }
            });
            
        });
    });


function createHiddenInput(productName) {
    const hiddenInputsContainer = document.getElementById('hiddenInputsContainer');
    // Check if an input with the same value already exists
    const existingInput = hiddenInputsContainer.querySelector(`input[value="${productName}"]`);
    if (existingInput) {
        return; // Exit the function if the input already exists
    }
    hiddenInputsContainer.querySelectorAll('input').forEach((input, index) => {
        input.name = `properties[ITEM ${index + 1}]`;
    });
    hiddenInputsContainer.querySelectorAll('input').forEach((input, index) => {
        input.name = `properties[ITEM ${index + 1}]`;
    });
    let inputCount = 1;

    // Find the highest count
    hiddenInputsContainer.querySelectorAll('input').forEach(input => {
        const regex = /properties\[ITEM\s+(\d+)\]/;
        const match = regex.exec(input.name);
        if (match) {
            inputCount = Math.max(inputCount, parseInt(match[1]) + 1);
        }
    });
   

    // Create a new input with the incremented count
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = `properties[ITEM ${inputCount}]`;
    input.value = productName;
    hiddenInputsContainer.appendChild(input);
}

function removeHiddenInput(productName) {
    
    const hiddenInputsContainer = document.getElementById('hiddenInputsContainer');
    hiddenInputsContainer.querySelectorAll('input').forEach((input, index) => {
        input.name = `properties[ITEM ${index + 1}]`;
    });
    const inputToRemove = hiddenInputsContainer.querySelector(`input[value="${productName}"]`);
    if (inputToRemove) {
        hiddenInputsContainer.removeChild(inputToRemove);
    }
}


function scrollSection() {
    
    var tabLinks = document.querySelectorAll('.tab');
    
   
    tabLinks.forEach(function(tabLink) {
        tabLink.addEventListener('click', function(event) {
            // Remove 'active-tab' class from all tab links
            tabLinks.forEach(function(link) {
                link.classList.remove('active-tab');
            });
            
            event.preventDefault(); 
            var tabId = tabLink.getAttribute('data-id'); 
            var tabContent = document.querySelector('.tab-content[data-id="' + tabId + '"]'); 

            // Scroll to the tab content
            tabContent.scrollIntoView({ behavior: 'smooth' });
            var scrollPosition = tabContent.getBoundingClientRect().top - (window.innerHeight * 0.2);
            window.scrollBy({ top: scrollPosition, behavior: 'smooth' });
        });
    });

    // Function to activate tab based on scroll position
    function activateTab() {
        const tabs = document.querySelectorAll('.tab');
        document.querySelectorAll('.tab-content').forEach(content => {
            const rect = content.getBoundingClientRect();
            if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
                const contentTabId = content.getAttribute('data-id');
                tabs.forEach(tab => {
                    if (tab.getAttribute('data-id') === contentTabId) {
                        tab.classList.add('active-tab');
                    } else {
                        tab.classList.remove('active-tab');
                    }
                });
            }
        });
    }
    
    // Activate tab on page load
    activateTab();
}

function imageAnimation() {
    var parentDivs = document.querySelectorAll('.product-item__inner');
    parentDivs.forEach(function(parentDiv) {
        var image = parentDiv.querySelector('.product-item__image--two');

        parentDiv.addEventListener('mouseover', function() {
            image.classList.add('active');
        });

        parentDiv.addEventListener('mouseout', function() {
            image.classList.remove('active');
        });
    });
}

function handleScroll() {
    // Get all tab links
    const tabs = document.querySelectorAll('.tab');

    // Loop through each tab content
    document.querySelectorAll('.tab-content').forEach(content => {
        // Check if the content is in the viewport
        const rect = content.getBoundingClientRect();
        if (rect.top <= window.innerHeight && rect.bottom >= 0) {

            // Find the corresponding tab link and add the active class
            const tabId = content.getAttribute('data-id');
            tabs.forEach(tab => {
                if (tab.getAttribute('data-id') === tabId) {
                    tab.classList.add('active-tab');
                } else {
                    tab.classList.remove('active-tab');
                }
            });
        }
    });
}

async function addProductWithRetry(productId, properties, retries) {
    for (let attempt = 1; attempt <= retries; attempt++) {
        try {
            await new Promise(resolve => setTimeout(resolve, 300));
            await addProductToCartMin(productId, properties);
            break;
        } catch (error) {
            console.error(`Failed to add product ID ${productId} to cart (attempt ${attempt}):`, error);
            if (attempt === retries) {
                console.error(`Giving up after ${retries} attempts`);
            }
        }
    }
}

async function addProductToCartMin(productId, properties) {
    const data = {
        quantity: 1,
        id: productId,
        properties: properties
    };

    try {
        let response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.statusText}`);
        }
    } catch (error) {
        console.error('Error adding product to cart:', error);
        throw error;
    }
}
